module.exports = __webpack_public_path__ + "img/Tumer.1b5fb961.svg";